import { render, staticRenderFns } from "./SuZhouRule.vue?vue&type=template&id=74b8fbac&scoped=true&"
import script from "./SuZhouRule.vue?vue&type=script&lang=js&"
export * from "./SuZhouRule.vue?vue&type=script&lang=js&"
import style0 from "./SuZhouRule.vue?vue&type=style&index=0&id=74b8fbac&scoped=true&lang=css&"
import style1 from "./SuZhouRule.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b8fbac",
  null
  
)

export default component.exports